import { types } from "mobx-state-tree";
import qs from "query-string";
export const model = types
    .model({
    featureFlags: types.map(types.model({
        enabled: types.boolean,
        store: types.boolean,
    })),
    showTranslationKeys: types.boolean,
    devModalVisible: types.boolean,
})
    .actions((self) => ({
    toggleFeature: (key, store = false) => self.featureFlags.set(key, {
        enabled: !self.featureFlags.get(key)?.enabled,
        store,
    }),
    setFeature: (key, enabled, store = false) => self.featureFlags.set(key, {
        enabled,
        store,
    }),
    resetTransientFeatures: () => {
        self.featureFlags.forEach((flag, key) => {
            if (!flag.store) {
                self.featureFlags.set(key, {
                    enabled: false,
                    store: false,
                });
            }
        });
    },
    initFeatures: (...keys) => {
        // decode feature enabled by query string from URL
        const featureFlagsFromQuery = [];
        const featureFlagsFromQueryEncoded = qs.parse(window.location.search).featureFlags;
        if (typeof featureFlagsFromQueryEncoded === "string") {
            try {
                const featureFlagsFromQueryDecoded = JSON.parse(atob(featureFlagsFromQueryEncoded));
                if (Array.isArray(featureFlagsFromQueryDecoded)) {
                    featureFlagsFromQuery.push(...featureFlagsFromQueryDecoded);
                }
            }
            catch (err) {
                console.error("Error while decoding feature flags query parameter", err);
            }
        }
        self.featureFlags.forEach((flag, key) => {
            // delete unsupported features
            if (!keys.includes(String(key))) {
                self.featureFlags.delete(String(key));
            }
            else if (!flag.store) {
                // reset transient features
                self.featureFlags.set(key, {
                    enabled: false,
                    store: false,
                });
            }
        });
        keys.forEach((key) => {
            // demo mode should be persistent even on reload since it can be easily toggled off anytime
            // so if it's demo mode we use isDemoKey as the store value
            const isDemoKey = key === "useDemoData";
            const existingFeature = self.featureFlags.get(key);
            // add missing features
            if (!existingFeature) {
                self.featureFlags.set(key, {
                    enabled: false,
                    store: isDemoKey,
                });
            }
            // enable features from query string
            if (featureFlagsFromQuery.includes(key)) {
                self.featureFlags.set(key, {
                    enabled: true,
                    store: existingFeature?.enabled ?? isDemoKey,
                });
            }
        });
    },
    toggleShowTranslationKeys: () => {
        self.showTranslationKeys = !self.showTranslationKeys;
    },
    setDevModalVisibility: (visible) => {
        self.devModalVisible = visible;
    },
}))
    .views((self) => ({
    featureEnabled: (feature) => !!self.featureFlags.get(feature)?.enabled,
    getFeatureFlags: () => self.featureFlags.entries(),
}));
export const devStore = model.create({
    featureFlags: {},
    showTranslationKeys: false,
    devModalVisible: false,
});
export default devStore;
//# sourceMappingURL=data:application/json;base64,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